export enum UserRole {
  RESIDENT = 'resident',
  TENANT = 'tenant',
}
